import { darken, lighten } from '@mui/material';

export const generateShadowColor = (color: string) => {
	if (!color) return [];
	const coefficientLight = [0.1, 0.25, 0.4, 0.55];
	const coefficientDark = [0.1, 0.25, 0.4, 0.55];
	const colorList = coefficientDark.map(it => darken(color, it)).concat(coefficientLight.map(it => lighten(color, it)));
	return colorList;
};
